class RichTextTable {
    constructor(table) {
        this.removeAllAttributesFromElement(table);
        this.resolveTableHeaders(table);
        this.addSurroundingElements(table, true);
    }

    resolveTableHeaders(table) {
        const firstRow = table.querySelector('tbody tr:first-child');

        Array.from(firstRow.querySelectorAll('td')).forEach((td) => {
            const th = document.createElement('th');
            th.textContent = td.textContent;
            td.parentNode.replaceChild(th, td);
        });
    }

    removeAllAttributesFromElement(table) {

        const attributesToKeep = [
            'href', 
            'target'
        ];
        
        table.querySelectorAll('*').forEach((element) => {
            Array.from(element.attributes).forEach((attribute) => {
                if (!attributesToKeep.includes(attribute.name)) {
                    element.removeAttribute(attribute.name);
                }
            });
        });

        Array.from(table.attributes).forEach((attribute) => {
            table.removeAttribute(attribute.name);
        });
    }

    showLightbox(table) {
        const modalClass = "rich-text-table__modal";
        const modal = document.createElement('div');
        modal.classList.add(modalClass);

        modal.addEventListener('click', (e) => {
            if (e.target.classList.contains(modalClass)) {
                document.querySelector(`.${modalClass}`).remove();
            }
        });

        const closeButton = document.createElement('button');
        closeButton.classList.add(`${modalClass}-close`);
        closeButton.setAttribute('aria-label', "Stäng modal")
        modal.appendChild(closeButton);

        closeButton.addEventListener('click', () => {
            document.querySelector(`.${modalClass}`).remove();
        });

        const modalContainer = document.createElement('div');
        modalContainer.classList.add(`${modalClass}-container`);

        const clonedTable = table.cloneNode(true);

        modalContainer.appendChild(clonedTable);
        modal.appendChild(modalContainer);

        document.body.appendChild(modal);

        this.addSurroundingElements(clonedTable, false);

        document.querySelector(`.${modalClass}-close`).focus();
    }

    addSurroundingElements(table, addButton =  false) {
        const wrapper = document.createElement('div');
        wrapper.classList.add('rich-text-table');

        const clonedTable = table.cloneNode(true);

        const subWrapper = document.createElement('div');
        subWrapper.classList.add('rich-text-table__container');
        subWrapper.setAttribute("data-simplebar", null);
        subWrapper.appendChild(clonedTable);

        wrapper.appendChild(subWrapper);

        if (addButton) {
            const button = document.createElement('button');
            button.textContent = "Visa i helskärm";
            button.classList.add('rich-text-table__button');

            button.addEventListener('click', () => this.showLightbox(table));

            wrapper.appendChild(button);
        }

        table.parentNode.replaceChild(wrapper, table);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    [...document.querySelectorAll('.rich-text table:not([class])')].forEach((table) => {
        new RichTextTable(table);
    });
});

